module.exports = __webpack_public_path__ + "static/media/41-3.612b54b6.mp3";